import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_STORES_BEGIN](state) {
    state.storesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_STORES_SUCCESS](state, stores) {
    state.storesGetError = null;
    state.stores = stores;
    state.storesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_STORES_ERROR](state, err) {
    state.storesGetState = API_STATES.REQUEST_ERROR;
    state.storesGetError = err;
  },
  [types.DELETE_STORE_BEGIN](state) {
    state.storeDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_STORE_SUCCESS](state, id) {
    state.storeDeleteError = null;
    state.storeDeleteState = API_STATES.REQUEST_SUCCESS;
    const index = findIndex(state.stores, function(o) {
      return o.id === id;
    });
    state.stores.splice(index, 1);
  },
  [types.DELETE_STORE_ERROR](state, err) {
    state.storeDeleteState = API_STATES.REQUEST_ERROR;
    state.storeDeleteError = err;
  }
};

export default mutations;
